import api from "../axios_service.js";

export async function fetchClientesColaborador(id) {
  const response = await api.get(`/colaborador/clientes-colaborador/${id}`);
  return response.data.result;
}
